import type { OtPurposesByCategoryAndUser } from "@jti/fe-common";
import { CasPurposesApi } from "@jti/rest-api";

import type { ProfileApiBuilder } from "../profileApiSlice.types";
import { handleProfileApiError } from "../utils/handleProfileApiError";

export const getUserConsentsEndpoint = (builder: ProfileApiBuilder) => ({
  getUserConsents: builder.query<OtPurposesByCategoryAndUser[], "all">({
    queryFn: async () => {
      try {
        const response = (await CasPurposesApi.init().getPurposesForUserByCategory(
          "all"
        )) as OtPurposesByCategoryAndUser[];
        return { data: response };
      } catch (error: unknown) {
        return handleProfileApiError(error);
      }
    },
  }),
});
